export const joyrideLocales = {
  back: 'Tilbake',
  close: 'Lukk',
  last: 'Lukk',
  next: 'Neste',
  open: 'Åpne',
  skip: 'Ikke nå',
}
